import { connect, MapDispatchToPropsNonObject } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Stack } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { createScopedActions } from '@mews-commander/utils';
import {
    startJSONDownload as startJSONDownloadAction,
    scheduleImport as scheduleImportAction,
} from '../../actions/export';
import { getGeneratedExportData } from '../../selectors/export';
import { createJSONUrl, stringifyJSONData } from '../../utils';
import { DownloadButtonElement } from './style';

type ExportDataType = ReturnType<typeof getGeneratedExportData>;

interface StateProps {
    exportData: ExportDataType;
}

interface ConnectedScopedActions {
    startJSONDownload: typeof startJSONDownloadAction;
    scheduleImport: typeof scheduleImportAction;
}

interface OwnProps {
    scope: string;
}

type ExportConfigurationButtonsProps = OwnProps & StateProps & ConnectedScopedActions;

const ExportConfigurationButtons = ({
    startJSONDownload,
    scheduleImport,
    exportData,
}: ExportConfigurationButtonsProps) => {
    const handleDirectImport = () => scheduleImport(exportData);
    const JSONString = stringifyJSONData(exportData);

    return (
        <Stack itemAlignment="center" alignment="end" spacing="100">
            <DownloadButtonElement
                onClick={startJSONDownload}
                href={createJSONUrl(JSONString)}
                download="mews-config.json"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
            >
                <LocalizedText textKey={TextKey.DownloadJson} />
            </DownloadButtonElement>
            <Button variant="primary" onClick={handleDirectImport} type="submit">
                <LocalizedText textKey={TextKey.DirectImport} />
            </Button>
        </Stack>
    );
};

export default connect<StateProps, ConnectedScopedActions, OwnProps, ApplicationState>(
    createStructuredSelector({
        exportData: getGeneratedExportData,
    }),
    createScopedActions({
        startJSONDownload: startJSONDownloadAction,
        scheduleImport: scheduleImportAction,
    }) as MapDispatchToPropsNonObject<ConnectedScopedActions, OwnProps>
)(ExportConfigurationButtons);
